// Third-party
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Components
import ModifyEnterpriseMemberForm from '../forms/ModifyEnterpriseMemberForm';
import EnterpriseMember from '@/types/enterprise-member';
import User from '@/types/user';
import Modal from '@/views/components/modals/AccessibleModal';

type Props = {
  user: User;
  show: boolean;
  memberToUpdate: EnterpriseMember;
  onCancel: () => void;
  onSave: (fname: string, lname: string, email: string, uid?: string, nameId?: string) => Promise<void>;
};

const ModifyEnterpriseMemberModal = (props: Props) => (
  <Modal show={props.show} className="modify-enterprise-member-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>
        <FormattedMessage id="Admin.Enterprise.ModifyMember" />
      </Modal.Title>
    </Modal.Header>

    <Modal.Body className="d-flex flex-column">
      <ModifyEnterpriseMemberForm
        user={props.user}
        onModifyMember={props.onSave}
        onCancel={props.onCancel}
        modifyButtonTextKey="Common.Save"
        successTextKey="Admin.Enterprise.ModifyMemberSuccess"
        memberToUpdate={props.memberToUpdate}
      />
    </Modal.Body>
  </Modal>
);

export default ModifyEnterpriseMemberModal;
